module.exports = __webpack_public_path__ + "static/ringworld-e6c9616ad2ccd81a8935aba915c43eda.jpg";